import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Action } from '@app/_models';

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  constructor(private http: HttpClient) { }

  getAll(filter?: object) {
    let fstr = filter  ? stringi(filter) : '&';
    return this.http.get<Action[]>(`/api/actions?${fstr.substring(1)}`);
  }

  getById(id: string) {
    return this.http.get<Action>(`/api/actions/${id}`);
  }

  update(name: string, params: any) {
    return this.http.put<Action>(`/api/actions/${name}`, params);
  }

  add(params: any) {
    return this.http.post<Action>(`/api/actions`, params);
  }

  delete(name: string) {
    return this.http.delete(`/api/actions/${name}`);
  }
}

function stringi(ob: any, path = ''): string {
  if (typeof ob === 'object') {
      if (path.length)
          return Object.keys(ob).map(k => stringi(ob[k], `${path}[${k}]`)).join('');
      else
          return Object.keys(ob).map(k => stringi(ob[k], k)).join('');
  }
  else
      return '&' + path + '=' + ob;
}
